<template>
    <div class="d-block">
        <page-banner v-bind:data="bannerData" v-if="bannerData"/>
        <div class="public-tabs-nav">
            <a class="tabs-nav" :class="{active: tabsActive === index}" v-for="(item, index) in language === 'zh-cn' ? tabsNav.cn : tabsNav.en" :key="index" @click="onPublicTabs(item, index)">
                <span class="d-block" style="padding: 0 72px;">{{ item }}</span>
            </a>
        </div>
        <div class="list-container">
            <div class="public-tabs-content">
                <div class="d-block" v-if="tabsActive === 0">
                    <div class="news-item" v-for="(item, index) in newsList" :key="index">
                        <!-- 图片靠左 -->
                        <div class="d-flex height-all" v-if="index % 2 === 0">
                            <div class="d-flex-item">
                                <div class="item-cover">
                                    <img class="photo" alt="" :src="item.cover"/>
                                    <span class="link animated zoomIn" @click="toDetails(item, index)">
                                        <Icon type="ios-link" color="#fff" size="40"/>
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex-item p-xl overflow-hidden" style="background: #f9f9f9;">
                                <div class="d-flex justify-start" style="width: 100%;">
                                    <div class="d-block pr-md bdr-1">
                                        <p class="size-20 c-success line-h-24">{{ $moment(new Date(item.updateTime).getTime()).format("MM-DD") }}</p>
                                        <p class="size-24 c-dark line-h-30">{{ $moment(new Date(item.updateTime).getTime()).format("YYYY") }}</p>
                                    </div>
                                    <div class="d-flex-item plr-md overflow-hidden">
                                        <h1 class="d-block overflow-text">
                                            <a class="c-black th-success" @click="toDetails(item, index)">{{ item.title }}</a>
                                        </h1>
                                    </div>
                                </div>
                                <div class="d-block mtb-md overflow-hidden" style="max-height: 180px; overflow: hidden;">
                                    <p class="size-18 line-h-30">{{ item.introduction }}</p>
                                </div>
                                <p>{{ language === 'zh-cn' ? '作者' : 'Author' }}：{{ item.author }}</p>
                                <div class="view-more align-right">
                                    <a class="btn" @click="toDetails(item, index)">
                                        <span class="d-flex justify-start">
                                            <Icon type="ios-arrow-dropright" size="20"/>
                                            <u class="pl-xs">{{ language === 'zh-cn' ? '详情' : 'View More' }}</u>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- 图片靠右 -->
                        <div class="d-flex height-all" v-else>
                            <div class="d-flex-item p-xl overflow-hidden" style="background: #f9f9f9;">
                                <div class="d-flex justify-start" style="width: 100%;">
                                    <div class="d-block pr-md bdr-1">
                                        <p class="size-20 c-success line-h-24">{{ $moment(new Date(item.updateTime).getTime()).format("MM-DD") }}</p>
                                        <p class="size-24 c-dark line-h-30">{{ $moment(new Date(item.updateTime).getTime()).format("YYYY") }}</p>
                                    </div>
                                    <div class="d-flex-item plr-md overflow-hidden">
                                        <h1 class="d-block overflow-text">
                                            <a class="c-black th-success" @click="toDetails(item, index)">{{ item.title }}</a>
                                        </h1>
                                    </div>
                                </div>
                                <div class="d-block mtb-md " style="max-height: 180px; overflow: hidden;">
                                    <p class="size-18 line-h-30">{{ item.introduction }}</p>
                                </div>
                                <p>{{ language === 'zh-cn' ? '作者' : 'Author' }}：{{ item.author }}</p>
                                <div class="view-more align-left">
                                    <a class="btn" @click="toDetails(item, index)">
                                        <span class="d-flex justify-start">
                                            <Icon type="ios-arrow-dropright" size="20"/>
                                            <u class="pl-xs">{{ language === 'zh-cn' ? '详情' : 'View More' }}</u>
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div class="d-flex-item">
                                <div class="item-cover">
                                    <img class="photo" :src="item.cover"/>
                                    <a class="link animated zoomIn" @click="toDetails(item, index)">
                                        <Icon type="ios-link" color="#fff" size="40"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-center bd-1" v-if="newsList.length === 0">
                        <div class="d-block align-center" style="padding: 64px;">
                            <p><Icon type="ios-warning" size="72" color="#ff9900"/></p>
                            <br/>
                            <br/>
                            <h1>{{ language === 'zh-cn' ? '没有更多内容了' : 'No more content' }}</h1>
                            <br/>
                            <br/>
                            <h6>
                                <a class="btn-load-more" @click="__reloadNews">
                                    <span class="plr-xxl">{{ language === 'zh-cn' ? '重新加载' : 'Reload' }}</span>
                                </a>
                            </h6>
                        </div>
                    </div>
                    <div class="d-block align-center" v-if="newsList.length > 0">
                        <a class="btn-load-more" @click="__getMoreNews">
                            <span class="plr-xxl">{{ language === 'zh-cn' ? '加载更多' : 'Loading More' }}</span>
                        </a>
                    </div>
                </div>
                <div class="d-block" v-if="tabsActive === 1">
                    <div class="news-item" v-for="(item, index) in activityList" :key="index">
                        <!-- 图片靠左 -->
                        <div class="d-flex height-all" v-if="index % 2 === 0">
                            <div class="d-flex-item">
                                <div class="item-cover">
                                    <img class="photo" :src="item.cover"/>
                                    <a class="link animated zoomIn" @click="toDetails(item, index)">
                                        <Icon type="ios-link" color="#fff" size="40"/>
                                    </a>
                                </div>
                            </div>
                            <div class="d-flex-item p-xl overflow-hidden" style="background: #f9f9f9;">
                                <div class="d-flex justify-start" style="width: 100%;">
                                    <div class="d-block pr-md bdr-1">
                                        <p class="size-20 c-success line-h-24">{{ $moment(new Date(item.updateTime).getTime()).format("MM-DD") }}</p>
                                        <p class="size-24 c-dark line-h-30">{{ $moment(item.date).format("YYYY") }}</p>
                                    </div>
                                    <div class="d-flex-item plr-md overflow-hidden">
                                        <h1 class="d-block overflow-text">
                                            <a class="c-black th-success" @click="toDetails(item, index)">{{ item.title }}</a>
                                        </h1>
                                    </div>
                                </div>
                                <div class="d-block mtb-md overflow-hidden" style="max-height: 180px; overflow: hidden;">
                                    <p class="size-18 line-h-30">{{ item.introduction }}</p>
                                </div>
                                <p>{{ language === 'zh-cn' ? '作者' : 'Author' }}：{{ item.author }}</p>
                                <div class="view-more align-right">
                                    <a class="btn" @click="toDetails(item, index)">
                                        <span class="d-flex justify-start">
                                            <Icon type="ios-arrow-dropright" size="20"/>
                                            <u class="pl-xs">{{ $store.state.language === 'zh-cn' ? '详情' : 'View More' }}</u>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- 图片靠右 -->
                        <div class="d-flex height-all" v-else>
                            <div class="d-flex-item p-xl overflow-hidden" style="background: #f9f9f9;">
                                <div class="d-flex justify-start" style="width: 100%;">
                                    <div class="d-block pr-md bdr-1">
                                        <p class="size-20 c-success line-h-24">{{ $moment(item.date).format("MM-DD") }}</p>
                                        <p class="size-24 c-dark line-h-30">{{ $moment(item.date).format("YYYY") }}</p>
                                    </div>
                                    <div class="d-flex-item plr-md overflow-hidden">
                                        <h1 class="d-block overflow-text">
                                            <a class="c-black th-success" @click="toDetails(item, index)">{{ item.title }}</a>
                                        </h1>
                                    </div>
                                </div>
                                <div class="d-block mtb-md overflow-hidden" style="max-height: 180px; overflow: hidden;">
                                    <p class="size-18 line-h-30">{{ item.introduction }}</p>
                                </div>
                                <p>{{ language === 'zh-cn' ? '作者' : 'Author' }}：{{ item.author }}</p>
                                <div class="view-more align-left">
                                    <a class="btn" @click="toDetails(item, index)">
                                        <span class="d-flex justify-start">
                                            <Icon type="ios-arrow-dropright" size="20"/>
                                            <u class="pl-xs">{{ $store.state.language === 'zh-cn' ? '详情' : 'View More' }}</u>
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div class="d-flex-item">
                                <div class="item-cover">
                                    <img class="photo" :src="item.cover"/>
                                    <a class="link animated zoomIn" @click="toDetails(item, index)">
                                        <Icon type="ios-link" color="#fff" size="40"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-center bd-1" v-if="activityList.length === 0">
                        <div class="d-block align-center" style="padding: 64px;">
                            <p><Icon type="ios-warning" size="72" color="#ff9900"/></p>
                            <br/>
                            <br/>
                            <h1>{{ language === 'zh-cn' ? '没有更多内容了' : 'No more content' }}</h1>
                            <br/>
                            <br/>
                            <h6>
                                <a class="btn-load-more" @click="__reloadActivity">
                                    <span class="plr-xxl">{{ language === 'zh-cn' ? '重新加载' : 'Reload' }}</span>
                                </a>
                            </h6>
                        </div>
                    </div>
                    <div class="d-block align-center" v-if="activityList.length > 0">
                        <a class="btn-load-more" @click="__getMoreActivity">
                            <span class="plr-xxl">{{ language === 'zh-cn' ? '加载更多' : 'Loading More' }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import PageBanner from "../../components/PageBanner";

    export default {
        components: {
            PageBanner
        },
        data () {
            return {
                language: 'zh-cn',
                bannerData: null,
                tabsNav: {
                    cn: ['新闻', '活动'],
                    en: ['News', 'Events'],
                },
                tabsActive: 0,
                newsList: [],
                activityList: [],
                newsTotal: 0,
                activityTotal: 0,
                current: 1,
                pageSize: 10,
            }
        },
        created() {
            console.log('当前语言----->' + this.$store.state.language);
            this.language = this.$store.state.language;
        },
        mounted() {
            this.__getBanner();
            this.__getNewsList(this.current);
            this.__getActivityList(this.current);
        },
        methods: {
            onPublicTabs(data, i){
                console.log(data, i);
                this.tabsActive = i;
            },
            __getBanner(){
                this.$api.getHttp('banner?bannerType=NEWS_ACTIVITIES', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.bannerData = res.data.data;
                        // console.log(this.bannerData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getNewsList(page){
                this.$api.getHttp('news?pageIndex=' + page + "&pageSize=" + this.pageSize + "&enable=" + true, {
                    language: this.language,
                }).then((res) => {
                    console.log('<---------- res ---------->');
                    console.log(res);
                    if (res.status === 200){
                        this.newsTotal = res.data.data.total;
                        this.newsList = [];
                        var _data = res.data.data.data;
                        _data.forEach(item=>{
                            item.type = 'NEWS';
                            this.newsList.push(item);
                        });
                        // console.log('newsList---------->');
                        // console.log(this.newsList);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getActivityList(page){
                // if (page === 0) {
                //     page = this.current;
                // }
                // if (page !== 0) {
                //     this.current = page;
                // }
                this.$api.getHttp('activities?pageIndex=' + page + "&pageSize=" + this.pageSize + "&enable=" + true, {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.activityTotal = res.data.data.total;
                        this.activityList = [];
                        var _data = res.data.data.data;
                        _data.forEach(item=>{
                            item.type = 'ACTIVITY';
                            this.activityList.push(item);
                        });
                        // console.log('activityList---------->');
                        // console.log(this.activityList);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            toDetails(data, i){
                console.log(data, i);
                // 获取随机数
                // var num = arrayData.[Math.floor(Math.random() * 4)];
                this.$router.push({
                    name: "newsDetails",
                    params: {
                        data: JSON.stringify(data),
                    }
                });
            },
            __reloadNews(){
                this.current = 1;
                this.__getNewsList(this.current);
            },
            __reloadActivity(){
                this.current = 1;
                this.__getActivityList(this.current);
            },
            __getMoreNews(){
                this.__getNewsList(this.current + 1);
            },
            __getMoreActivity(){
                this.__getActivityList(this.current + 1);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/news/list.vue